export default __webpack_public_path__ + "static/media/math.9b5eb3156e035a194af9cc4d9d964428.svg";